// Mobile pagination dots for the .products.feed scroll-snap slider.
// Wires up: (1) clicking a dot scrolls to that item; (2) scrolling updates
// the active dot via IntersectionObserver. No external libs.

export function initProductsPagination(container) {
  const track = container.querySelector('.feed_articles');
  const dots = container.querySelectorAll('.feed_pagination__dot');
  const slides = container.querySelectorAll('.feed_item');

  if (!track || dots.length === 0 || slides.length === 0) return;

  // Click → scroll to slide. Use scrollIntoView with inline:start so the
  // browser respects the container's scroll-padding.
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const target = slides[index];
      if (!target) return;
      target.scrollIntoView({
        behavior: 'smooth',
        inline: 'start',
        block: 'nearest'
      });
    });
  });

  // Track which slide is currently centered/visible and update the dots.
  // Using the track as the root means we observe relative to the scroll
  // container, not the viewport.
  const setActive = (index) => {
    dots.forEach((d, i) => {
      const active = i === index;
      d.classList.toggle('is-active', active);
      d.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      // Pick the entry with the highest intersection ratio (the slide most
      // in view) and mark its dot active.
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

      if (visible) {
        const index = Array.from(slides).indexOf(visible.target);
        if (index !== -1) setActive(index);
      }
    },
    {
      root: track,
      threshold: [0.5, 0.75, 1]
    }
  );

  slides.forEach((slide) => observer.observe(slide));
}

export function autoInitProductsPagination() {
  document.querySelectorAll('.products.feed').forEach((container) => {
    if (container.dataset.paginationInit === 'true') return;
    container.dataset.paginationInit = 'true';
    initProductsPagination(container);
  });
}
